export var extractCategoryFromJRNICategoryName = function (jrniCategoryName) {
    if (/Kitchen/i.test(jrniCategoryName))
        return 'kitchen';
    if (/Storage/i.test(jrniCategoryName))
        return 'bedroom';
    if (/Storage/i.test(jrniCategoryName))
        return 'bedroom';
    if (/Energy.*Follow/i.test(jrniCategoryName))
        return 'energy-follow-up';
    if (/Energy/i.test(jrniCategoryName))
        return 'energy';
    // Previous solution
    return jrniCategoryName.split(' ').pop().toLowerCase();
};
